module.exports = __webpack_public_path__ + "static/media/logo_esn_en.adeada34.svg";